// Waar bewaarde filters leven — en hoe lang.
//
// Filters horen bij je HUIDIGE werksessie, niet bij je account. Stonden ze in
// localStorage, dan vond je bij een volgende aanmelding (dagen later) nog altijd
// de filters van toen terug: een pagina die stilletjes maar een deel van de data
// toont, zonder dat je nog weet waarom. Daarom sessionStorage — dat overleeft een
// refresh en het heen-en-weer tussen pagina's, maar niet het sluiten van het
// tabblad — plus een expliciete opruiming bij het aanmelden (zie clearSavedFilters,
// aangeroepen vanuit AuthContext).
//
// Wil je een filterstand écht bewaren, dan is daar de FilterFavorites-knop voor:
// die staat server-side en is een bewuste keuze van de gebruiker.
//
// LET OP: dit gaat enkel over FILTERS. De actieve pagina en de subpagina's
// leven ook per sessie, maar via sessieOpslag.js (dat ook de sessiegrens bewaakt
// en bij een nieuwe sessie alles hier wist). Thema en tabelkeuzes blijven in
// localStorage staan — die verwarren niemand.

const SUFFIX = '.filters';

// Alle opslagsleutels die filters bevatten, in beide opslagplaatsen. localStorage
// zit erbij om de nalatenschap van de oude opzet op te ruimen: zonder die stap
// zou een gebruiker die vóór deze wijziging filters bewaarde ze nooit meer kwijt
// raken.
function filterKeys(store) {
  const out = [];
  try {
    for (let i = 0; i < store.length; i++) {
      const k = store.key(i);
      if (k && k.endsWith(SUFFIX)) out.push(k);
    }
  } catch { /* private mode / storage geblokkeerd */ }
  return out;
}

// Lees een bewaarde filterstand. Geeft null bij afwezig of onleesbaar.
export function readSavedFilters(key) {
  try {
    const raw = window.sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function writeSavedFilters(key, json) {
  try { window.sessionStorage.setItem(key, json); } catch { /* ignore */ }
}

// Gooi elke bewaarde filterstand weg. Aangeroepen bij het aanmelden (en bij
// impersonatie, die door dezelfde functie loopt), zodat iedereen met een schone,
// volledige lijst begint.
export function clearSavedFilters() {
  for (const store of [window.sessionStorage, window.localStorage]) {
    for (const k of filterKeys(store)) {
      try { store.removeItem(k); } catch { /* ignore */ }
    }
  }
}
